const KEY = 'signup_source'

// 첫 방문 유입 경로를 기록한다(first-touch). OAuth 왕복 후엔 referrer가 구글/카카오로 바뀌므로 첫 진입 시점에 잡는다.
export function captureSignupSource() {
  try {
    if (localStorage.getItem(KEY)) return
    const utm = new URLSearchParams(location.search).get('utm_source')
    const ref = document.referrer ? new URL(document.referrer).hostname : ''
    const source = utm || (ref && ref !== location.hostname ? ref : 'direct')
    localStorage.setItem(KEY, source.slice(0, 100))
  } catch {
    // 저장소 접근 불가 시 기록 생략
  }
}

export function getSignupSource(): string | null {
  try {
    return localStorage.getItem(KEY)
  } catch {
    return null
  }
}
